module.exports = __webpack_public_path__ + "static/media/przemiana2_left.970a6bf3.jpeg";